import * as React from "react";

import * as DTO from "../../../interfaces";
import { printOnlyDate, URLS } from "@/utils";
import { Svg } from "@/assets";

import { PromptType } from "@/interfaces";
import LibraryCard from "../LibraryCard";

interface OwnProps {
  prompt: DTO.Prompt;
  onClick?: () => void;
}

type Props = OwnProps;

const PromptCardFC: React.FC<Props> = ({ prompt: { promptId, title, creationDate, post, type }, onClick }: Props) => {
  const thumbnail = React.useMemo(() => {
    if (post?.media[0] && post?.media[0].uri) {
      const creativeUrl = post?.media[0].uri;
      if (post?.media[0].category === "IMAGE") {
        return creativeUrl;
      } else if (post?.media[0].thumbnailUri) {
        return post.media[0].thumbnailUri;
      }
    }
    return undefined;
  }, [post?.media]);

  return (
    <LibraryCard
      href={onClick ? undefined : URLS.coach.prompt.replace(":promptId", `${promptId}`)}
      title={title}
      dateLabel={creationDate ? printOnlyDate(creationDate) : undefined}
      thumbnail={thumbnail}
      floatingIcon={type === PromptType.REELS ? Svg.Reels : undefined}
      onClick={() => onClick?.()}
    />
  );
};

export const PromptCard = PromptCardFC;
